"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importStar(require("react"));
const note_styles_1 = require("./note.styles");
const close_button_1 = require("../../buttons/close_button");
const button_1 = __importDefault(require("../../buttons/button"));
const get_string_length_1 = require("../../../util/get_string_length");
const ACTIVE_CONTAINER_HEIGHT = 200;
class Note extends react_1.Component {
    constructor(props) {
        super(props);
        this.textareaRef = react_1.default.createRef();
        this.wrapperRef = react_1.default.createRef();
        this.handleClickOutside = (e) => {
            if (this.state.isFocused &&
                !!this.wrapperRef.current &&
                !this.wrapperRef.current.contains(e.target)) {
                this.saveNote();
                this.handleFocusLost();
            }
        };
        this.fitStaticHeightToContent = () => {
            if (this.props.disableAutoGrow) {
                return;
            }
            this.setState({ activeHeight: 1 }, () => {
                const scrollHeight = this.textareaRef.current
                    ? this.textareaRef.current.scrollHeight
                    : ACTIVE_CONTAINER_HEIGHT;
                const activeHeight = scrollHeight > ACTIVE_CONTAINER_HEIGHT ? ACTIVE_CONTAINER_HEIGHT : scrollHeight;
                this.setState({ activeHeight: activeHeight });
            });
        };
        this.handleFocusLost = () => {
            this.setState({ isFocused: false }, this.fitStaticHeightToContent);
        };
        this.handleFocus = () => {
            if (this.state.isFocused) {
                return;
            }
            this.setState({
                noteDraft: this.state.note,
                isFocused: true,
            });
        };
        this.handleBlur = (e) => {
            const goingTo = e.relatedTarget;
            if (goingTo) {
                const { current } = this.wrapperRef;
                const inParent = current && current.contains(goingTo);
                if (!inParent) {
                    this.saveNote();
                    this.handleFocusLost();
                }
            }
        };
        this.saveNote = () => {
            const updatedNote = this.state.noteDraft ? this.state.noteDraft.trim() : '';
            this.setState({ note: updatedNote });
            this.props.onSave(updatedNote);
        };
        this.handleSaveClick = () => {
            this.saveNote();
            this.handleFocusLost();
        };
        this.handleCancelClick = () => {
            this.handleFocusLost();
        };
        this.isAtCharLimit = (count) => {
            return count >= this.charLimit;
        };
        this.handleInputChange = (e) => {
            let noteDraft = e.target.value;
            const charCount = this.getCharCount(noteDraft);
            const isTooLong = this.isAtCharLimit(charCount);
            if (isTooLong) {
                noteDraft = noteDraft.substring(0, this.charLimit);
            }
            this.setState({
                noteDraft: noteDraft,
                noteLimitReached: isTooLong,
            }, this.fitStaticHeightToContent);
        };
        this.getCharCount = (note) => {
            return (0, get_string_length_1.getStringLength)(note || '');
        };
        this.renderCharCount = () => {
            const { noteDraft } = this.state;
            if (!noteDraft) {
                return null;
            }
            return `${this.getCharCount(noteDraft)}/${this.charLimit}`;
        };
        this.charLimit = this.props.characterLimit;
        this.state = {
            note: '',
            noteDraft: '',
            noteLimitReached: false,
            activeHeight: this.props.disableAutoGrow ? undefined : ACTIVE_CONTAINER_HEIGHT,
            isFocused: false,
        };
    }
    componentDidMount() {
        this.setState({
            note: this.props.noteText,
            noteDraft: this.props.noteText,
        }, this.fitStaticHeightToContent);
        if (!this.props.disableEditing) {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.noteText !== this.props.noteText && !!this.props.noteText) {
            this.setState({ note: this.props.noteText });
        }
    }
    componentWillUnmount() {
        if (!this.props.disableEditing) {
            document.removeEventListener('mousedown', this.handleClickOutside);
            if (this.props.noteText !== this.state.noteDraft) {
                this.saveNote();
            }
        }
    }
    render() {
        const { note, noteDraft, isFocused, activeHeight, noteLimitReached } = this.state;
        const { disableEditing } = this.props;
        return ((0, jsx_runtime_1.jsxs)(note_styles_1.NoteContainer, Object.assign({ style: this.props.style, ref: this.wrapperRef }, { children: [(0, jsx_runtime_1.jsx)(note_styles_1.NoteTextArea, { ref: this.textareaRef, value: isFocused ? noteDraft : note, onChange: this.handleInputChange, onFocus: this.handleFocus, onBlur: this.handleBlur, isFocused: disableEditing ? false : isFocused, activeHeight: activeHeight, placeholder: disableEditing ? '-- N/A --' : `${this.props.placeholderText}`, maxLength: this.charLimit, disabled: disableEditing, 
                    // Keeps textarea white when not focused when rendered as a RoomNote (for live call view)
                    style: this.props.textareaStyle && this.props.textareaStyle }), isFocused && ((0, jsx_runtime_1.jsxs)(note_styles_1.NoteFooter, { children: [(0, jsx_runtime_1.jsx)(button_1.default, Object.assign({ variant: "primary", onBlur: this.handleBlur, onClick: this.handleSaveClick }, { children: "Save" })), (0, jsx_runtime_1.jsx)(close_button_1.CloseButton, { label: "cancel note edit", onBlur: this.handleBlur, onClick: this.handleCancelClick }), (0, jsx_runtime_1.jsx)(note_styles_1.CharCounter, Object.assign({ noteLimitReached: noteLimitReached, characterLimit: this.charLimit, charCount: this.getCharCount(noteDraft) }, { children: this.renderCharCount() }))] }))] })));
    }
}
exports.default = Note;
//# sourceMappingURL=note.js.map